import { User } from "lucide-react";
import type { ReactElement } from "react";
import { getInitials } from "@/features/dashboard/utils/string-helpers";

/** Whether `name` has a letter in any script. */
export function hasLetters(name: string): boolean {
	return /\p{L}/u.test(name);
}

/**
 * What an avatar shows for a contact: the name's initials, or a person icon
 * when the name has no letters (a contact saved from a WhatsApp chat can be
 * named by its number, whose initial would be "+").
 */
export function ContactInitials({ name }: { name: string }): ReactElement {
	if (!hasLetters(name)) {
		return <User className="h-4 w-4" aria-hidden data-testid="contact-icon" />;
	}
	return <>{getInitials(name)}</>;
}
